enum ProcessStatus {
  SUCCESS = 'STATUS_OK',
  LOADING = 'STATUS_LOADING',
  ERROR = 'STATUS_ERROR',
  STANDBY = 'STATUS_STANDBY',
}

export default ProcessStatus;
